import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { BusinessSignedService } from 'src/app/kuba/businesses/services/businessSigned.service';
import { BaseServices } from 'src/app/kuba/kuba.services';
import { Observable } from 'rxjs';

@Injectable()
export class BusinessSignedListResolver {
    constructor(private backend: BusinessSignedService) {}
    resolve(route: ActivatedRouteSnapshot): Observable<any[]> {
        return this.backend.getAllUsers(BaseServices.BusinessId);
    }
}
